import React, { useEffect, useState, useRef } from "react";
import { TableWork } from "../../../ui";
import Select from "../../../library/components/Select/index";
import BarcodeReader from "react-barcode-reader";
import Button from "../../../library/components/Button";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
} from "../../../constants/constants";
import { createAlert } from "../../../features/alert/alerts";
import InputField from "../../../library/components/InputField";
import { useDispatch } from "react-redux";
import {
  duplicate_plus,
  green_check,
  purple_excla,
  red_cross,
} from "../../../images";
import { TableLabel } from "./TableLabel";
import { Validators } from "../../../library/utilities/Validator";
import { Enter_Reason, FILED_IS_REQUIRED } from "../../../constants/constants";
import {
  useAddElectorMannualy13BMutation,
  useGetForm13aQuery,
  useGetForm13BQuery,
  useGetForm13CQuery,
  useInvalid13BMutation,
  useScanner13BMutation,
} from "../../../services/preCountingServices";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../../library/components/Modal/modal";
import "./index.css";
import alertIcon from "../../../dashboardicon/alert.svg"
import { isValidFileNameFormBandFormAleft } from "../../utilities/utils";

export const FormB = ({
  isShowCameraPopup,
  onCameraPopopUpdate,
  onCameraPopopError,
  setonCameraPopopUpdate,
}) => {
  const [Data, setData] = useState({});
  const [form13AState, setform13AState] = useState({
    isForm13AValid: true,
    form13ASrNo: "",
    form13AName: "",
  });
  const [isformBDisable, setIsformBDisable] = useState(false);
  // const [form13CState, setform13CState] = useState({
  //   isForm13CValid: true,
  //   form13CSrNo: "",
  // });
  const tableBody = [];
  const [, setErrorValue] = useState({});
  const { data: userData, refetch } = useGetForm13BQuery();
  const dispatch = useDispatch();
  const [invalidReason, datac] = useInvalid13BMutation();
  const [scanData, setScanData] = useState("");
  const [addElector, datab] = useAddElectorMannualy13BMutation();
  const [scanForm13B, datap] = useScanner13BMutation();
  const [isDuplicateAllowed, setisDuplicateAllowed] = useState("");
  const [remove, setRemove] = useState(false);
  const [error, setError] = useState(false);
  const [showConfirmationPopup, setConfirmationPopup] = useState(false);
  const [showConfirmationPopupInvalid, setConfirmationPopupInvalid] =
    useState(false);
  const [showePbIDCOnfirmation,setShowePbIDCOnfirmation]= useState(false)
  const { data: form13A } = useGetForm13aQuery();
  const { data: form13C } = useGetForm13CQuery();
  const [alertMessage, setAlertMessage] = useState(false);
  const [JunkalertMessage, setJunkAlertMessage] = useState(false);
  const [storedScanData,setStoredScanData] = useState("")
  const debounceTimeout = useRef(null);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    let data = form13A?.payload;
    let form13CData = form13C?.payload?.responseStatusForm13cDtoList;
    if (data?.length > 0) {
      setform13AState({
        isForm13AValid:
          data?.[0]?.form13aLcScanStatus === "V" &&
          data?.[0]?.form13aRcScanStatus === "V",
        form13ASrNo: data?.[0]?.slNo13A,
        form13AName: data?.[0]?.fullName,
        epbID:form13CData?.[0]?.epbId
      });
      // if (
      //   data?.[0]?.form13cScanStatus === "V" &&
      //   form13a?.payload?.[0]?.slNo13A != data?.[0]?.slNo13C
      // ) {
      //   setIsformADisable(false);
      // }
      if (
        form13CData?.[0]?.form13cScanStatus === "N" ||
        form13CData?.[0]?.form13cScanStatus === "D" ||
        form13CData?.[0]?.form13cScanStatus === "I" ||
        data?.[0]?.form13aLcScanStatus === "N" ||
        data?.[0]?.form13aRcScanStatus === "N" ||
        data?.[0]?.form13aLcScanStatus === "I" ||
        data?.[0]?.form13aRcScanStatus === "I"
      ) {
        setIsformBDisable(true);
      }
      if (
        data?.[0]?.form13aLcScanStatus === "V" &&
        data?.[0]?.form13aRcScanStatus === "V" &&
        data?.[0]?.slNo13A == userData?.payload?.[0]?.slNo13B &&
        userData?.payload?.[0]?.slNo13B == form13CData?.[0]?.slNo13C &&
        userData?.payload?.[0]?.form13bScanStatus != ""
      ) {
        setIsformBDisable(true);
      }
      if (
        form13CData?.[0]?.form13cScanStatus === "V" &&
        (data?.[0]?.slNo13A !== form13CData?.[0]?.slNo13C || data?.length == 0)
      ) {
        setIsformBDisable(true);
      }
    } else {
      setIsformBDisable(true);
    }
  }, [form13A, userData]);

  userData?.payload.map((item, i) => {
    tableBody.push({
      "S.No": item.slNo13B,
      Status:
        item.form13bScanStatus === "V" ? (
          <TableLabel icon={green_check} color={"#24bc2a"} label={"Valid"} />
        ) : item.form13bScanStatus === "I" ? (
          <TableLabel
            icon={red_cross}
            color={"#E30000"}
            label={item.invalidation}
          />
        ) : item.form13bScanStatus === "D" ? (
          <TableLabel
            icon={duplicate_plus}
            color={"#E66E00"}
            label={"Duplicate"}
          />
        ) : (
          item.form13bScanStatus === "N" && (
            <TableLabel
              icon={purple_excla}
              color={"#8D00BE"}
              label={item.messge}
            />
          )
        ),
    });
    window.scrollTo(0, 0);
  });
  const handleChange = (key, value) => {
    if(key !=="Other Reason for Manual Invalidation OR Not Scanning"){
      setData((prevState) => ({
        ...prevState,
  
        ["Other_Reason"]:null,
      }));
    }

    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const onProceed = () => {
    setConfirmationPopupInvalid(false);
    setData((prev) => ({ ...prev, ["Selected_reason"]: "" }));
    if (Data.Selected_Reason) {
      if(Data.Selected_Reason=="Other Reason for Manual Invalidation OR Not Scanning" & (Data.Other_Reason==null||Data.Other_Reason==undefined||Data.Other_Reason=="")){
        onInfo("Please Enter the Reason for Manual Invalidation");
        return
      }
      invalidReason({
        invalidReason: Data.Other_Reason
          ? Data.Other_Reason
          : Data.Selected_Reason,
      })
        .unwrap()
        .then((res) => {
          refetch();
        });
      Data.Other_Reason = "".unwrap().then((res) => {
        refetch();
      });
    } else {
      onInfo("Select Reason for invalidation");
    }
  };
  const getErrorValue = (key, value) => {
    setErrorValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const initiPbid = {
    0: "",
    1: "",
    2: "",
    3: "",
  };
  const [PBID, setPBID] = useState({
    0: "",
    1: "",
    2: "",
    3: "",
  });
  const data = {
    head: ["S. No.", "Scanned"],
  };
  const handlePbid = (key, value) => {
    setPBID({ ...PBID, [key]: "" + value });
    if (value.length >= 4) {
      // Check if it's not the last input field
      if (key !== "4") {
        // Get the next input field
        const nextSibling = document.querySelector(
          `input[name=in-${Number(key) + 1}]`
        );
        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    } else if (value.length == 0) {
      if (key != 0) {
        // Get the prev input field
        const prevSibling = document.querySelector(
          `input[name=in-${Number(key) - 1}]`
        );
        // If found, focus the next field
        if (prevSibling !== null) {
          prevSibling.focus();
        }
      }
    }
  };
  const addEPBID = () => {
    setShowePbIDCOnfirmation(false)
    if (PBID[0] + PBID[1] + PBID[2] + PBID[3]) {
      addElector({
        epbId: PBID[0] + PBID[1] + PBID[2] + PBID[3],
        isFirstTimeScan: isDuplicateAllowed,
      })
        .unwrap()
        .then((res) => {
          if (res?.statusCode == 200) {
            if (res?.message?.includes("previously scanned")) {
              setConfirmationPopup(true);
              onInfo(res?.message);
            } else {
              if (res.statusCode == 200) {
                if(res.message?.includes("Not issued by")){
                  onInfo(res?.message)
                }
                else{ onSuccess(res?.message);}
              }
            }
          } else {
            onInfo(res?.message);
          }
          refetch();
          setPBID(initiPbid);
        })
        .catch(() => {
          refetch();
          setPBID(initiPbid);
        });
    } else {
      onInfo("Please Enter EPB-id");
    }

    refetch();
  };

  const listManualInvalidation = [
    {
      label:
        "Select Reason for Manual Invalidation/Not Scanning of not Scanning Form 13-B",
      value:
        "",
    },
    {
      label:
        " Form 13-B is not Found/Does not exist for the service voter (" +
        form13AState.form13AName +
        "  of the current Form 13-A being Scanned)",
      value:
        "Form 13-B is not Found OR Does not exist for the service voter (" +
        form13AState.form13AName +
        "  of the current Form 13-A being Scanned)",
    },
    {
      label: " Other Reason for Manual Invalidation/Not Scanning",
      value: "Other Reason for Manual Invalidation OR Not Scanning",
    },
  ];


  const handleScan = (data) => {
  

    if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          setJunkAlertMessage(false);
          setAlertMessage(true);
            setScanData(""); // Clear the scan data
        }, 200); // Debounce time in milliseconds
    } else {
        debounceTimeout.current = setTimeout(() => {
            debounceTimeout.current = null; // Reset debounce timeout
            if(!isValidFileNameFormBandFormAleft(data,form13AState.epbID)){
              setStoredScanData(data)
              setJunkAlertMessage(true);
              return
            }else{
              setScanData(data);
            }
            setAlertMessage(false); // Clear any previous alert
            // runApi(data); // Call the API directly here
        }, 450); // Debounce time in milliseconds
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  useEffect(() => {
    if (scanData !== "") {
      setJunkAlertMessage(false);
      setStoredScanData("")
      debounceTimeout.current = null;
      scanForm13B({
        epbId: scanData,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.statusCode == 200) {
            if (res?.message?.includes("previously scanned")) {
              onInfo(res?.message);
            } else {
              onSuccess(res?.message);
            }
          } else {
            onInfo(res?.message);
          }
          refetch();
        })
        .catch(() => refetch());
    }
  }, [scanData]);

  useEffect(() => {
    // if (datap.isError) {
    //   // onReject(datap?.error?.data?.message);
    // }
    // if (datap.isSuccess && datap?.data?.message !== "Duplicate Scan") {
    //   onSuccess(datap?.data?.message);
    // }
    // if (
    //   datap?.data?.message?.includes(
    //     "Duplicate scan detected against serial no"
    //   )
    // ) {
    //   setConfirmationPopup(true);
    // }
  }, [datap.isError, datap.isSuccess]);

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  /////////////////////Web Cam Code
  // useEffect(() => {
  //   if (isShowCameraPopup && onCameraPopopUpdate) {
  //     handleScan(onCameraPopopUpdate);
  //     setonCameraPopopUpdate("");
  //   }
  // }, [onCameraPopopUpdate]);

  ////////////////////////////////////

  useEffect(() => {
    if (datab.isError) {
      // onReject(datab?.error?.data?.message);
    }
    if (datab.isSuccess) {
      // onSuccess(datab?.data?.message);
    }
  }, [datab.isError, datab.isSuccess]);

  useEffect(() => {
    if (datac.isError) {
      // onReject(datac?.error?.data?.message);
    }
    if (datac.isSuccess) {
      onSuccess(datac?.data?.message);
    }
  }, [datac.isError, datac.isSuccess]);

  const onClose = () => {
    setConfirmationPopup(false);
    setScanData("");
  };
  const onCloseEPBConfirmation = () =>{
    setShowePbIDCOnfirmation(false)
  }
  const onCloseInvalid = () => {
    setData((prev) => ({ ...prev, ["Selected_reason"]: "" }));
    setConfirmationPopupInvalid(false);
    // invalidReason("");
  };

  // const reset = (event) => {
  //   scanForm13B({
  //     epbId: scanData,
  //     isFirstTimeScan: "Yes",
  //   }).then((res) => {
  //     refetch();
  //   });
  //   setRemove(false);
  //   setConfirmationPopup(false);
  //   setScanData("");
  // };
  const confirmationForProceed = () => {
    setConfirmationPopupInvalid(true);
  };

  return (
    <>
   {
        <CustomModal
          className="confirmation_modal"
          show={JunkalertMessage}
          // onClose={()=>{setJunkAlertMessage(false)}}
          closeIcon={false}
          size="700px"
          modalTitle={<>
            <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
        <hr/>
          </>
          }
          children={  
            <>
             <p style={{fontSize:"17px" ,marginBottom:"40px"}}>Your QR Code Scanner has returned invalid value, or you must have scanned wrong QR Code. You may try to scan again, or reset your QR Code scanner or replace the Computer or add manually.<br/> If you want to scan again or add manually click on <span style={{backgroundColor:"#007bff", padding:"2px", borderRadius:"2px",color:"white",fontWeight:600}}>"Scan Again/Add Manually"</span> else click on <span style={{backgroundColor:"#ffc107", padding:"2px", borderRadius:"2px",color:"black",fontWeight:600}}>"Proceed With The Scanned Value"</span> to proceed with the value that you have scanned.<br/><span style={{ color:"red"}}> Note that if you proceed with the scanned value, the system will mark it as invalid.</span></p>
            <button type="button" className="btn btn-warning" onClick={()=>{
           setScanData(storedScanData);
            }} style={{
              float:"left",
              margin:"15px"
            }}>Proceed With The Scanned Value</button>
            <button type="button" className="btn btn-primary" onClick={()=>{
           setJunkAlertMessage(false);
           setStoredScanData("");
            }} style={{
              float:"right",
              margin:"15px"
            }}>Scan Again/Add Manually</button>
            </>
          }         
        />
      }
     {
        <CustomModal
          className="confirmation_modal"
          show={alertMessage}
          onClose={()=>{setAlertMessage(false);
          setScanData("");
          debounceTimeout.current = null
          }}
          closeIcon={false}
          size="700px"
          modalTitle={<>
            <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
        <hr/>
          </>
          }
          children={  
            <>
            <p style={{fontSize:"17px"}}>Your QR Code Scanner has returned multiple values, it should return only one value at a time. You may try to scan again, or reset your QR Code scanner or replace the Computer. In case the QR Code returns multiple values, keep on scanning again or try on another computer with your own login id. If it still persist, you may add manually.</p>
            <button type="button" className="btn btn-primary" onClick={()=>{
              setAlertMessage(false);
              setScanData("");
              debounceTimeout.current = null
            }} style={{
              float:"right",
              margin:"15px"
            }}>OK</button>
            </>
          }         
        />
      }
      {/* {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to scan again ?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onClose}
              yesOption={reset}
            />
          }
        />
      } */}
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupInvalid}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to Invalidate this Record?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onCloseInvalid}
              yesOption={onProceed}
            />
          }
        />
      }
        {
          <CustomModal
          className="confirmation_modal"
          show={showePbIDCOnfirmation}
          size="500px"
          closeIcon={false}
          modalTitle={
            "Are you sure you have entered the correct e-PB id as on FORM 13-B ?"
          }
          children={
            <div>
          <div style={{paddingBottom:"30px"}}>
             <span style={{fontSize: "18px",
    color: "red",
    fontWeight: 700,}}>ePB-Id: </span><span style={{fontSize: "30px",
    color: "black",
    fontWeight: 700,
    fontFamily: "monospace",
    paddingLeft: "24px",}}>{PBID[0].toUpperCase()}-{PBID[1].toUpperCase()}-{PBID[2].toUpperCase()}-{PBID[3].toUpperCase()}</span>
             </div>
    <ConfirmationModal
              // title="You want to delete this"
              noOption={()=>setShowePbIDCOnfirmation(false)}
              yesOption={addEPBID}
            />
            </div>
          }
        />
      }
      <BarcodeReader onError={handleError} onScan={handleScan} />
      <div className="form-default">
        <div className="head-title mb-3">
          <div className="for_pbid mb-2">
            <div className="row ">
              <strong className="col-md-3">
                Reason for manual invalidation / not scanning
              </strong>

              <div className="row col-md-7">
                <Select
                  placeholder="Select Reason for manual invalidation / not scanning"
                  labelClass=""
                  inputClass="col-md-12"
                  value={Data.Selected_Reason}
                  options={listManualInvalidation}
                  disabled={isformBDisable}
                  selectClass="select-class"
                  handleChange={(val) => handleChange("Selected_Reason", val)}
                />
                {Data.Selected_Reason ===
                  "Other Reason for Manual Invalidation OR Not Scanning" && (
                  <InputField
                    name="Other_Reason"
                    placeholder="Enter the Reason for Manual Invalidation"
                    required={true}
                    inputClass="col-md-12"
                    labelClass=""
                    disabled={isformBDisable}
                    value={Data.Other_Reason}
                    onChange={(val) => handleChange("Other_Reason", val)}
                    getError={(value) => getErrorValue("Other_Reason", value)}
                    validators={[
                      {
                        check: Validators.required,
                        message: FILED_IS_REQUIRED,
                      },
                    ]}
                  />
                )}
              </div>

              <Button
                value="Proceed"
                onClick={confirmationForProceed}
                btnClass="proceed-btn"
                disabled={isformBDisable}
              />
            </div>
          </div>
          <span className="mb-2">
            <strong className="mr-1">Enter e-PBID </strong>
            (Add e-PBID Manually in case QR Code is not scanned)
          </span>
          <div className="add-elector">
            {[0, 1, 2, 3].map((inputItem) => (
              <InputField
                name={"in-" + inputItem}
                maxLength={4}
                disabled={isformBDisable}
                onChange={(value) => handlePbid(inputItem, value)}
                inputClass="input-class"
                value={PBID[inputItem]}
                onKeyPress={(evt) => [" "].includes(evt.key) && evt.preventDefault()}
                //inputClass="mr-2"
              />
            ))}
            <Button
              fa_icon="fa-plus plus-icon"
              value="Add"
              onClick={()=>{ if (PBID[0].length==4 && PBID[1].length==4 && PBID[2].length==4 && PBID[3].length==4){
                setShowePbIDCOnfirmation(true)
              }else{
                onInfo("Please Enter 16 digit EPB-id")
              }}}
              disabled={isformBDisable}
              btnClass="add-button"
            />
            <Button
              value="Reset"
              btnClass="reset-button"
              disabled={isformBDisable}
              onClick={() => setPBID(initiPbid)}
            />
          </div>
        </div>
        <TableWork
          id=""
          theadData={data.head}
          tbodyData={tableBody}
          anchorTagName=""
          anchorTagclassName="viewDetails"
          emptyMessage="No data found"
          pageSize={10}
          pagination={true}
          paginationClass={"text-right p-0"}
        />
      </div>
    </>
  );
};
